import React, { useState } from "react";
import Body from "./Body";

const Programs = () => {
  const [filter, setFilter] = useState({
    gender: "all",
  });
  const [classesFilter, setClassesFilter] = useState([]);
  const [subjectInputsContainerCount, setSubjectInputsContainerCount] =
    useState(1);
  const [programAddModal, setProgramAddModal] = useState(false);
  const _this = {
    filter,
    setFilter,
    classesFilter,
    setClassesFilter,
    subjectInputsContainerCount,
    setSubjectInputsContainerCount,
    programAddModal,
    setProgramAddModal,
  };
  return <Body {..._this} />;
};

export default Programs;
